<script setup lang="ts">
import type { NavigationLinkFragment, NavigationTreeFragment } from '#graphql-operations'

interface SubmenuMobileNestedProps {
  nav: NavigationLinkFragment
  children: NavigationTreeFragment[]
}

defineProps<SubmenuMobileNestedProps>()

const activeChild = ref<NavigationTreeFragment | null>(null)

function animateEnter(_el: Element, done: gsap.Callback) {
  gsap.timeline({ defaults: { duration: 0.7, ease: 'circ3' }, onComplete: done })
    .to('.headerNavMobile', { x: '-=100vw' })
}

function animateLeave(_el: Element, done: gsap.Callback) {
  gsap.timeline({ defaults: { duration: 0.7, ease: 'circ3' }, onComplete: done })
    .to('.headerNavMobile', { x: '+=100vw' })
}
</script>

<template>
  <div>
    <ul class="grid space-y-2.5">
      <li v-for="child in children" :key="child.id" class="inline-flex">
        <ButtonNav :title="child.title" @click="activeChild = child">
          <!-- <template #icon>
            <i class="i-icon-arrow-right motion-base flex-none icon" />
          </template> -->
        </ButtonNav>
      </li>
    </ul>

    <Transition @enter="animateEnter" @leave="animateLeave">
      <nav v-show="activeChild" class="submenu size-full left-100vw top-0 absolute z-1">
        <div class="space-y-4">
          <button class="inline-flex gap-2 items-center justify-center" @click.stop.prevent="activeChild = null">
            <i class="i-icon-arrow-left size-5 icon" />
            <Text class="typo-sans-1 uppercase capsize" :text="`${$t('back_to')} ${nav.title}`" />
          </button>
          <p v-if="activeChild" class="typo-sans-1 c-$accent-color mb-6 underline underline-offset-1 block uppercase">
            {{ activeChild.title }}
          </p>
        </div>
        <SubmenuMobileSimple
          v-if="activeChild"
          :children="(activeChild.children as NavigationLinkFragment[])"
        />
      </nav>
    </Transition>
  </div>
</template>
